class ConsentTracking extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accept = this.querySelector('.popup--block--accept');
    this.decline = this.querySelector('.popup--block--decline');
    this.limit = this.parentNode.getAttribute('data-limit') === 'true';

    this.eventListeners();

    if (window.Shopify) {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: () => {
            const { marketing, analytics, preferences } =
              window.Shopify.customerPrivacy.currentVisitorConsent();
            const consent_empty = marketing === '' && analytics === '' && preferences === '';
            const show_banner = window.Shopify.customerPrivacy.shouldShowBanner() && consent_empty;

            if (show_banner) {
              this.open();
            } else if (theme.popup) {
              theme.popup.loadNext();
            }
          },
        },
      ]);
    }
  }

  eventListeners() {
    [this.accept, this.decline].on('click', ({ target }) => {
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: target === this.accept,
          marketing: target === this.accept,
          preferences: target === this.accept,
        },
        () => {
          this.close();
          !this.limit && theme.popup && theme.popup.loadNext();
        }
      );
    });

    if (Shopify.designMode) {
      this.on('theme:block:deselect', () => this.close());
      this.on('theme:block:select', () => {
        this.off('transitionend');
        this.open();
      });
    }
  }

  open() {
    this.setAttribute('aria-hidden', false);
    setTimeout(() => this.setAttribute('data-transition-active', true), 5);
  }

  close() {
    this.setAttribute('data-transition-active', false);
    this.on('transitionend', () => this.setAttribute('aria-hidden', true), { once: true });
  }
}

const consentTrackingEl = customElements.get('consent-tracking');
consentTrackingEl || customElements.define('consent-tracking', ConsentTracking);